import Swal from "sweetalert2";

export function extractToCSV(invalidData) {
  if (!invalidData || invalidData.length === 0) return;

  const headers = Object.keys(invalidData[0]).slice(0, -3);
  const rows = invalidData.map((obj) =>
    headers.map((header) => {
      const value = obj[header];
      if (
        typeof value === "string" &&
        (value.includes(",") || value.includes('"'))
      ) {
        return `"${value.replace(/"/g, '""')}"`;
      }
      return value;
    })
  );

  const csvContent = [headers, ...rows].map((row) => row.join(",")).join("\n");
  
  const utf8Bom = '\uFEFF';
  const contentWithBom = utf8Bom + csvContent;
  
  const blob = new Blob([contentWithBom], { type: 'text/csv;charset=utf-8' });
  
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", blobUrl);
  link.setAttribute("download", "registros_nao_processados.csv");

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  URL.revokeObjectURL(blobUrl);

  Swal.fire({
    icon: "success",
    title: "Download concluído",
    text: "O arquivo com os registros não processados foi baixado.",
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
  });
}

export function downloadTemplateCSV() {
  const headers = ["matricula", "dateOfBirth", "gender", "city", "state"];

  const exampleRows = [
    ["123456", "15/01/1980", "M", "São Paulo", "SP"],
    ["654321", "20/05/1992", "F", "Rio de Janeiro", "RJ"],
    ["789012", "23/07/1984", "M", "Belo Horizonte", "MG"],
  ];

  const csvContent = [headers, ...exampleRows].map((row) => row.join(",")).join("\n");
  
  const utf8Bom = '\uFEFF';
  const contentWithBom = utf8Bom + csvContent;
  
  const blob = new Blob([contentWithBom], { type: 'text/csv;charset=utf-8' });
  
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", blobUrl);
  link.setAttribute("download", "modelo_beneficiarios.csv");

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  URL.revokeObjectURL(blobUrl);

  Swal.fire({
    icon: "success",
    title: "Modelo baixado",
    text: "O arquivo modelo foi baixado. Use-o como referência para formatar seus dados.",
    timer: 3000,
    timerProgressBar: true,
    showConfirmButton: false,
  });
}
